module.exports = __webpack_public_path__ + "static/media/dec-Id-front.0dfc3cb1.gif";